"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTINUOUS_SEQUENCE_YEAR = exports.JOURNAL_SERIES = void 0;
exports.formatJournalNumber = formatJournalNumber;
exports.fiscalYearOf = fiscalYearOf;
exports.formatContinuousNumber = formatContinuousNumber;
/** سلسلة قيود اليومية. المستندات (فواتير، إشعارات) ستأخذ سلاسلها الخاصة. */
exports.JOURNAL_SERIES = 'JV';
const MIN_DIGITS = 6;
/**
 * رقم القيد: `JV-2026-000001` — السلسلة ثم السنة المالية ثم التسلسل.
 *
 * التسلسل يبدأ من ١ كل سنة مالية، فالرقم يُقرأ وحده بلا مرجع آخر. والأرقام
 * تُحشى إلى ستة لتترتب نصيًا كما تترتب عدديًا؛ وما يتجاوزها لا يُقص بل يطول.
 *
 * الصيغة نفسها **مقترحة** لا معتمدة — `BLOCKED-ACCOUNTING`: يقرّها المحاسب
 * (هل تُعاد كل سنة؟ هل سلسلة لكل نوع مصدر؟) قبل أول عميل حقيقى.
 */
function formatJournalNumber(series, fiscalYear, sequence) {
    if (!Number.isInteger(sequence) || sequence < 1) {
        throw new RangeError('journal sequence must be a positive integer, got ' + sequence);
    }
    if (!Number.isInteger(fiscalYear) || fiscalYear < 1900 || fiscalYear > 9999) {
        throw new RangeError('fiscal year out of range: ' + fiscalYear);
    }
    return series + '-' + fiscalYear + '-' + String(sequence).padStart(MIN_DIGITS, '0');
}
/** السنة المالية تُؤخذ من بداية الفترة لا من تاريخ القيد — سنة مالية تبدأ فى يوليو تبقى سنة واحدة. */
function fiscalYearOf(periodStartDate) {
    return Number(periodStartDate.slice(0, 4));
}
/**
 * رقم مستند بمسلسل مستمر لا يتجدد سنويًا (`documents.numbering = continuous`، ADR-0006):
 * `SI-000123` — السلسلة ثم التسلسل بلا سنة. لا يصطدم برقم سنوى (`SI-2026-000123`)
 * لأن الشكلين مختلفان، فتغيير الإعداد فى منتصف سنة لا يكرر رقمًا.
 */
function formatContinuousNumber(series, sequence) {
    if (!Number.isInteger(sequence) || sequence < 1) {
        throw new RangeError('document sequence must be a positive integer, got ' + sequence);
    }
    return series + '-' + String(sequence).padStart(MIN_DIGITS, '0');
}
/** السنة المحجوزة لعدّاد المسلسل المستمر فى جدول العدّادات — لا سنة مالية بهذا الرقم. */
exports.CONTINUOUS_SEQUENCE_YEAR = 0;
//# sourceMappingURL=journal-number.js.map